import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useView } from '../context/ViewContext';
import ProfileSettings from './ProfileSettings';

const Sidebar = () => {
    const navigate = useNavigate();
    const { isOwner, isOwnerView, user } = useView();
    const [showProfileSettings, setShowProfileSettings] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('viewMode');
        navigate('/login');
    };

    // Owner navigation items (when in owner view)
    const ownerNavItems = [
        {
            path: '/owner/production',
            label: 'Production Summary',
            description: 'All entities'
        },
        {
            path: '/owner/manage-orders',
            label: 'Manage Orders',
            description: 'Daily preparation'
        },
        {
            path: '/owner/orders',
            label: 'Orders',
            description: 'All orders'
        },
        {
            path: '/owner/alerts',
            label: 'Alerts',
            description: 'Warnings & flags'
        },
        {
            path: '/owner/raw-material-requests',
            label: 'Raw Material Requests',
            description: 'Requests from manufacturers'
        },
        {
            path: '/charts',
            label: 'Product Facts',
            description: 'Charts & Analytics'
        },
        {
            path: '/company-performance',
            label: 'Company Performance',
            description: 'Business metrics'
        },
        {
            path: '/owner/inventory',
            label: 'Inventory',
            description: 'Low stock alerts'
        }
    ];

    // Regular user navigation items (includes manufacturer view for owner)
    const regularNavItems = [
        {
            path: '/production',
            label: 'Production Summary',
            description: 'Daily product counts'
        },
        {
            path: '/manage-orders',
            label: 'Manage Orders',
            description: 'Daily preparation'
        },
        {
            path: '/orders',
            label: 'Orders',
            description: 'Manage orders'
        },
        {
            path: '/charts',
            label: 'Dashboard',
            description: 'Charts & Analytics'
        },
        {
            path: '/inventory',
            label: 'Inventory',
            description: 'Stock management'
        }
    ];

    // Use owner nav if owner AND in owner view mode
    const navItems = isOwnerView ? ownerNavItems : regularNavItems;

    // Only show profile settings for non-owner users
    const canEditProfile = !isOwnerView && user?.role && user.role !== 'owner';

    return (
        <>
            <aside className="sidebar">
                <div className="sidebar-header">
                    <div className="sidebar-logo">
                        <div className="logo-icon-box">R</div>
                        <div className="logo-text">
                            <h1>Rotica</h1>
                            <span>{isOwnerView ? 'Owner Panel' : 'Admin Panel'}</span>
                        </div>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    <ul className="nav-list">
                        {navItems.map((item, index) => (
                            <li key={item.path} className="nav-item" style={{ animationDelay: `${index * 0.05}s` }}>
                                <NavLink
                                    to={item.path}
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    <div className="nav-content">
                                        <span className="nav-label">{item.label}</span>
                                        <span className="nav-description">{item.description}</span>
                                    </div>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="sidebar-footer">
                    <div
                        className={`user-info ${canEditProfile ? 'clickable' : ''}`}
                        onClick={() => canEditProfile && setShowProfileSettings(true)}
                        title={canEditProfile ? 'Click to edit profile' : ''}
                    >
                        <div className="user-avatar-box" style={isOwnerView ? { background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' } : {}}>
                            {(user.name || 'A').charAt(0).toUpperCase()}
                        </div>
                        <div className="user-details">
                            <span className="user-name">
                                {user.name || 'Admin'}
                            </span>
                            <span className="user-role">
                                {isOwnerView ? 'Owner' : (user.role || 'Manager')}
                            </span>
                        </div>
                        {canEditProfile && (
                            <span className="edit-profile-icon">⚙️</span>
                        )}
                    </div>
                    <button className="logout-btn-sidebar" onClick={handleLogout}>
                        Logout
                    </button>
                </div>
            </aside>

            {/* Profile Settings Panel */}
            <ProfileSettings
                isOpen={showProfileSettings}
                onClose={() => setShowProfileSettings(false)}
            />
        </>
    );
};

export default Sidebar;

